var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_https_cus_shipment_portal_vela_com_vn_remoteEntry_mjs_0344d25b__;